// @ts-nocheck
import * as React from "react";
import { Ic, apiErrorMessage } from "../screens/common";
import { useEscapeKey } from "./useEscapeKey";

// Detail + resolve modal for the region dashboard's real-time alert list.
// Resolve marks the alert resolved_at and the parent drops it from the list
// on next refetch.

const SEVERITY_COLOR = { critical: "rose", warning: "amber", info: "sky" };
const SEVERITY_LABEL = { critical: "위험", warning: "경고", info: "알림" };

function fmtTime(iso) {
  if (!iso) return "-";
  try { return new Date(iso).toLocaleString("ko-KR", { dateStyle: "medium", timeStyle: "short" }); }
  catch { return iso; }
}

export function AlertDetailModal({ alert, onClose, onResolved }) {
  useEscapeKey(onClose);
  const [submitting, setSubmitting] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const color = SEVERITY_COLOR[alert.severity] || "sky";

  const resolve = async () => {
    setErr(null); setSubmitting(true);
    try {
      const r = await fetch(`/api/v1/alerts/${alert.id}/resolve`, {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        if (r.status === 401)      setErr("로그인이 필요합니다.");
        else if (r.status === 403) setErr(j.message || "해결 처리 권한이 없습니다.");
        else                       setErr(apiErrorMessage(j, r.status));
        return;
      }
      onResolved?.(j);
    } catch (e) { setErr(apiErrorMessage(e)); } finally { setSubmitting(false); }
  };

  return (
    <div onClick={onClose}
      style={{position:'fixed', inset:0, background:'rgba(20,16,12,0.4)', display:'grid', placeItems:'center', zIndex:50}}>
      <div onClick={e=>e.stopPropagation()} className="card" style={{width:520, padding:0}}>
        <div style={{padding:'16px 22px', borderBottom:'1px solid var(--border-soft)', display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:12}}>
          <div style={{minWidth:0, flex:1}}>
            <div style={{display:'flex', alignItems:'center', gap:8, marginBottom:6}}>
              <span className={"badge badge-" + color}>{SEVERITY_LABEL[alert.severity] || alert.severity}</span>
              {alert.kind && <span className="muted" style={{fontSize:11}}>{alert.kind}</span>}
            </div>
            <div className="h3" style={{wordBreak:'keep-all'}}>{alert.title}</div>
          </div>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose}>{Ic.close}</button>
        </div>

        {err && <div style={{margin:'14px 22px 0', padding:'10px 14px', background:'var(--rose-50)', color:'var(--rose-500)', borderRadius:10, fontSize:12.5}}>{err}</div>}

        <div style={{padding:22, display:'grid', gap:14}}>
          <div>
            <div className="label">상세 내용</div>
            <div style={{fontSize:13, lineHeight:1.55, whiteSpace:'pre-wrap'}}>{alert.message || '내용 없음'}</div>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:14}}>
            <div>
              <div className="label">관련 어르신</div>
              <div style={{fontSize:13}}>
                {alert.elderly_id
                  ? <a href={`/dashboard/guardian?elderly_id=${alert.elderly_id}`}
                       style={{color:'var(--orange-600)', fontWeight:600, textDecoration:'none'}}>
                      {alert.elderly_name || `#${alert.elderly_id}`} →
                    </a>
                  : <span className="muted">-</span>}
              </div>
            </div>
            <div>
              <div className="label">담당 매니저</div>
              <div style={{fontSize:13}}>
                {alert.care_manager_id
                  ? <a href={`/managers?id=${alert.care_manager_id}`}
                       style={{color:'var(--orange-600)', fontWeight:600, textDecoration:'none'}}>
                      {alert.manager_name || `#${alert.care_manager_id}`} →
                    </a>
                  : <span className="muted">-</span>}
              </div>
            </div>
          </div>

          <div>
            <div className="label">발생 시각</div>
            <div className="muted mono" style={{fontSize:12}}>{fmtTime(alert.created_at)}</div>
          </div>
        </div>

        <div style={{padding:'14px 22px', borderTop:'1px solid var(--border-soft)', display:'flex', justifyContent:'flex-end', gap:8}}>
          <button type="button" className="btn btn-ghost btn-md" onClick={onClose}>닫기</button>
          <button type="button" className="btn btn-primary btn-md" onClick={resolve} disabled={submitting || !!alert.resolved_at}>
            {alert.resolved_at ? '이미 처리됨' : (submitting ? '처리 중…' : '해결 처리')}
          </button>
        </div>
      </div>
    </div>
  );
}
